<!-- TEMPLATE -->
<template>
    <div :class='orderOverviewClass'>
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Orderregels</span>
            </span>
          </dean-section-title>
          <dean-notification>

          </dean-notification>
          <div class="filter">
            <dean-form-row
              @input="update(true)"
              v-model="pageMeta.query"
              class="top-bar"
              hide-label="true"
            >Zoek</dean-form-row>

            <div style="width: 30px;"></div>

            <button :class="{active: pageMeta.cloudService == true}" id="cloud">
              <dean-icon :glyph="deanCloudIcon"
              @click.native="pageMeta.cloudService = !Boolean(pageMeta.cloudService); update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="cloud" placement="bottom">
                Cloud
              </b-tooltip>
            </button>

            <button :class="{active: pageMeta.connectionService == true}" id="internet">
              <dean-icon :glyph="deanInternetIcon"
              @click.native="pageMeta.connectionService = !pageMeta.connectionService; update()"
              width="20"
              height="20"
              ></dean-icon>
            <b-tooltip target="internet" placement="bottom">
              Connection
            </b-tooltip>
            </button>

            <button :class="{active: pageMeta.mobileService == true}" id="mobile">
              <dean-icon :glyph="deanMobileOdidoIcon"
              @click.native="pageMeta.mobileService = !pageMeta.mobileService; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="mobile" placement="bottom">
                Odido Mobile
              </b-tooltip>
            </button>

            <button :class="{active: pageMeta.mobileKpnService == true}" id="mobilekpn">
              <dean-icon :glyph="deanMobileKpnIcon"
                         @click.native="pageMeta.mobileKpnService = !pageMeta.mobileKpnService; update()"
                         width="20"
                         height="20"
              ></dean-icon>
              <b-tooltip target="mobilekpn" placement="bottom">
                KPN Mobile
              </b-tooltip>
            </button>

            <button :class="{active: pageMeta.sipTrunkService == true}" id="siptrunk">
              <dean-icon :glyph="deanSipTrunkIcon"
                          @click.native="pageMeta.sipTrunkService = !pageMeta.sipTrunkService; update()"
                          width="20"
                          height="20"
              ></dean-icon>
              <b-tooltip target="siptrunk" placement="bottom">
                SIP Trunk
              </b-tooltip>
            </button>

            <div style="width: 30px;"></div>

            <button :class="{active: pageMeta.orderNew == true}" id="orderNew">
              <dean-icon :glyph="statusIcon"
              @click.native="pageMeta.orderNew = !pageMeta.orderNew; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="orderNew" placement="bottom">
                Nieuw
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderAccepted == true}" id="accepted">
              <dean-icon :glyph="wonIcon"
              @click.native="pageMeta.orderAccepted = !pageMeta.orderAccepted; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="accepted" placement="bottom">
                Geaccepteerd
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderOnHold == true}" id="onhold">
              <dean-icon :glyph="clockIcon"
              @click.native="pageMeta.orderOnHold = !pageMeta.orderOnHold; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="onhold" placement="bottom">
                On hold
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderPlanned == true}" id="gepland">
              <dean-icon :glyph="calendarTimeIcon"
              @click.native="pageMeta.orderPlanned = !pageMeta.orderPlanned; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="gepland" placement="bottom">
                Gepland
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderDelivered == true}" id="delivered">
              <dean-icon :glyph="checkmarkIcon"
              @click.native="pageMeta.orderDelivered = !pageMeta.orderDelivered; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="delivered" placement="bottom">
                Facturatie
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderTerminationRequested == true}" id="terminationrequest">
              <dean-icon :glyph="warningIcon"
              @click.native="pageMeta.orderTerminationRequested = !pageMeta.orderTerminationRequested; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="terminationrequest" placement="bottom">
                Opgezegd
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderTerminated == true}" id="terminated">
              <dean-icon :glyph="deleteIcon"
              @click.native="pageMeta.orderTerminated = !pageMeta.orderTerminated; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="terminated" placement="bottom">
                Beëindigd
              </b-tooltip>
            </button>
            <button :class="{active: pageMeta.orderDeclined == true}" id="declined">
              <dean-icon :glyph="forbiddenIcon"
              @click.native="pageMeta.orderDeclined = !pageMeta.orderDeclined; update()"
              width="20"
              height="20"
              ></dean-icon>
              <b-tooltip target="declined" placement="bottom">
                Afgewezen
              </b-tooltip>
            </button>

            <div style="width: 30px;"></div>

            <button :class="{active: pageMeta.hasComments == true}" id="comment">
              <dean-icon :glyph="commentIcon"
                         @click.native="pageMeta.hasComments = !pageMeta.hasComments; update()"
                         width="20"
                         height="20"
              ></dean-icon>
              <b-tooltip target="comment" placement="bottom">
                Opmerkingen
              </b-tooltip>
            </button>
          </div>

          <dean-table
            :data='orderData'
            :columns='columns'
            :hover="true"
            @column-click='columnClick'
            @cell-click="cellClick"
          >
            <span slot="service" slot-scope="service">
              <dean-icon v-for="serviceIcon in service.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
            <span slot="status" slot-scope="status">
              <dean-icon v-for="serviceIcon in status.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
            <span slot="comment" slot-scope="comment">
              <dean-icon v-for="serviceIcon in comment.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
          </dean-table>
          <dean-pagination
            :current-page='orderMetaData.pageNumber'
            :total-items='orderMetaData.totalResults'
            :items-per-page='orderMetaData.itemsPerPage'
            :select-items-per-page='selectItemsPerPage'
            :visible-pages='orderMetaData.visiblePages'
            @page-changed='paginationChanged'
            @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<!-- SCRIPT -->
<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import DeanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import {BTooltip} from 'bootstrap-vue';
  import {getDutchDateFormat} from '@/mixins/dateWrapper';
  import {OrderStatusEnum} from '@/enums/OrderStatusEnum';
  import {ServiceTypeEnum} from '@/enums/ServiceTypeEnum';

  import {
    // SVG
    invoicesIcon,
    ordersIcon,
    deanIcon,
    calendarTimeIcon,
    checkmarkIcon,
    warningIcon,
    deleteIcon,
    clockIcon,
    deanCloudIcon,
    deanInternetIcon,
    customIconSmartphoneKpn,
    customIconSmartphoneOdido,
    forbiddenIcon,
    customIconPhoneCall,
    messageIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
  } from '@deanone/dean-components';
  import deanNotification from '@/components/deanComponents/deanNotification.vue';
  import wonIcon from '@/assets/svg/won.svg';
  import statusIcon from '@/assets/svg/status.svg';
  import {servicesStringToIcons, statusStringToIcons} from '@/mixins/stringToIcons';
  import {getPhoneNumberFromOrderLine} from "@/mixins/additionalDataPhoneNumber";

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      deanIcon,
      deanNotification,
      deanFormRow,
      BTooltip,
      DeanSelectFormRow,
    },
  })

  export default class List extends mixins(deanTableMixin) {
    public data: object[] = [];
    public showSomething: boolean = false;
    public deanCloudIcon: object = deanCloudIcon;
    public deanInternetIcon: object = deanInternetIcon;
    public deanMobileOdidoIcon: object = customIconSmartphoneOdido;
    public deanMobileKpnIcon: object = customIconSmartphoneKpn;
    public deanSipTrunkIcon: object = customIconPhoneCall;
    public statusIcon: object = statusIcon;
    public wonIcon: object = wonIcon;
    public clockIcon: object = clockIcon;
    public calendarTimeIcon: object = calendarTimeIcon;
    public checkmarkIcon: object = checkmarkIcon;
    public warningIcon: object = warningIcon;
    public deleteIcon: object = deleteIcon;
    public forbiddenIcon: object = forbiddenIcon;
    public commentIcon: object = messageIcon;
    public queryTimeout!: number;

    // COMPUTED
    get orderOverviewClass() {
      let value = 'order-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get orderMetaData() {
      return this.pageMeta;
    }

    get orderData() {
      return this.data;
    }

    // DATA
    public sideMenu: object = {
      content: {
        title: {
          text: 'Orderregels',
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        sections: {
          filters: {
            title: 'sorteren op status',
            items: {
              all: {
                title: 'Alle',
                icon: ordersIcon,
                name: 'orderlines.overview',
              },
              received: {
                title: 'Nieuw',
                icon: statusIcon,
                name: 'orderlines.overview.status',
                params: {status: 'nieuw'},
              },
              accepted: {
                title: 'Geaccepteerd',
                icon: wonIcon,
                name: 'orderlines.overview.status',
                params: {status: 'geaccepteerd'},
              },
              onhold: {
                title: 'On hold',
                icon: clockIcon,
                name: 'orderlines.overview.status',
                params: {status: 'onhold'},
              },
              planned: {
                title: 'Gepland',
                icon: calendarTimeIcon,
                name: 'orderlines.overview.status',
                params: {status: 'gepland'},
              },
              delivered: {
                title: 'Facturatie',
                icon: checkmarkIcon,
                name: 'orderlines.overview.status',
                params: {status: 'facturatie'},
              },
              cancelled: {
                title: 'Opgezegd',
                icon: warningIcon,
                name: 'orderlines.overview.status',
                params: {status: 'opgezegd'},
              },
              terminated: {
                title: 'Beëindigd',
                icon: deleteIcon,
                name: 'orderlines.overview.status',
                params: {status: 'beeindigd'},
              },
            },
          },
        },
      },
    };

    get columns(): any {
      const columns: any = {
        orderNumber: {
          content: 'Ordernummer',
          align: 'left',
          sort: true,
          dql: 'orderNumber',
        },
      };
      if (this.$store.getters.getUser.privileges.includes('view-partner')) {
        columns.partnerName = {
          content: 'Naam partner',
          align: 'left',
          sort: true,
          dql: 'partnerName',
        };
      }
      return {
        ...columns, ...{
          customerName: {
            content: 'Klantnaam',
            align: 'left',
            sort: true,
            dql: 'customerName',
          },
          productName: {
            content: 'Product naam',
            align: 'left',
            sort: true,
            dql: 'productName',
          },
          monthlyAmount: {
            content: 'Maandbedrag',
            align: 'left',
            sort: true,
            dql: 'monthlyAmount',
          },
          createdDate: {
            content: 'Aangemaakt op',
            align: 'left',
            sort: true,
            dql: 'createdDate',
          },
          wishDate: {
            content: 'Wensdatum',
            align: 'left',
            sort: true,
            dql: 'wishDate',
          },
          deliveryDate: {
            content: 'Plandatum',
            align: 'left',
            sort: true,
            dql: 'deliveryDate',
          },
          invoiceDate: {
            content: 'Facturatiedatum',
            align: 'left',
            sort: true,
            dql: 'invoiceDate',
          },
          terminationRequestDate: {
            content: 'Opgezegd wensdatum op',
            align: 'left',
            sort: true,
            dql: 'terminationRequestDate',
          },
          service: {
            content: 'Diensten',
            type: 'slot',
            slot: 'service',
            align: 'center',
            dql: 'service',
          },
          status: {
            content: 'Status',
            type: 'slot',
            slot: 'status',
            align: 'center',
            dql: 'status',
          },
          comment: {
            content: 'Opmerkingen',
            type: 'slot',
            slot: 'comment',
            align: 'center',
            dql: 'comment',
          },
        },
      };
    }

    public tableName(): string {
      return 'orderlines';
    }

    // METHODS
    public cellClick(target: { cell: object, row: { id: string, orderId: string }, column: string }) {
      if (this.$store.getters.getUser.privileges.includes('view-orderline')) {
        this.$router.push({
          name: 'orders.orderline',
          params: {
            transactionId: target.row.orderId,
            cpId: target.row.id,
          },
        });
      }
    }

    public update(timeout: boolean|null = null) {
      this.pageMeta.pageNumber = 1;

      const self = this;
      const meta: any = self.pageMeta;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 800);
      } else {
        this.loadList(meta);
      }
    }

    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);
      const routeStatus = this.$route.params.status;

      let orderLinesListRequestUrl: string;

      if (
        this.$store.getters.getUser.organization
        &&
        this.$store.getters.getUser.organization.isProvider
      ) {
        orderLinesListRequestUrl = '/-/trade/api/admin.order.lines.list';
      } else {
        orderLinesListRequestUrl = '/-/trade/api/order.lines.list';
      }

      axios.post(orderLinesListRequestUrl, {
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
          startDate: data.startDate,
          endDate: data.endDate,
        },
        filter: data.query,
        sort: data.sort,
        partnerId: !this.$store.getters.getUser.organization.isProvider
          && this.$store.getters.getPartnerAgreement
          ? this.$store.getters.getUser.organizationId : undefined,
        hasComments: data.hasComments ? true : null,
        statuses: [
          ...(data.orderNew || routeStatus === 'nieuw' ? [OrderStatusEnum.IN_PROGRESS] : []),
          ...(data.orderAccepted  || routeStatus === 'geaccepteerd' ? [OrderStatusEnum.ACCEPTED] : []),
          ...(data.orderOnHold  || routeStatus === 'onhold' ? [OrderStatusEnum.ON_HOLD] : []),
          ...(data.orderPlanned  || routeStatus === 'gepland' ? [OrderStatusEnum.PLANNED] : []),
          ...(data.orderDelivered  || routeStatus === 'facturatie' ? [OrderStatusEnum.INVOICED] : []),
          ...(data.orderTerminationRequested  || routeStatus === 'opgezegd' ? [OrderStatusEnum.TERMINATION_REQUESTED] : []),
          ...(data.orderTerminated  || routeStatus === 'beeindigd' ? [OrderStatusEnum.TERMINATED] : []),
          ...(data.orderDeclined ? [OrderStatusEnum.DECLINED] : []),
        ],
        services: [
          ...(data.cloudService ? [ServiceTypeEnum.CLOUD] : []),
          ...(data.connectionService ? [ServiceTypeEnum.CONNECTION] : []),
          ...(data.mobileService ? [ServiceTypeEnum.MOBILE_ODIDO] : []),
          ...(data.mobileKpnService ? [ServiceTypeEnum.MOBILE_KPN] : []),
          ...(data.sipTrunkService ? [ServiceTypeEnum.SIP_TRUNK] : []),
        ],
      }).then(
        (response: any) => {
          this.data = response.data.data.map((orderLine: any) => {
            return {
              id: orderLine.id,
              orderNumber: orderLine.orderNumber,
              orderId: orderLine.orderId,
              partnerName: orderLine.partnerName,
              customerName: orderLine.customerName,
              productName: this.getProductName(orderLine),
              monthlyAmount: new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
              }).format(orderLine.monthlyAmount),
              createdDate: getDutchDateFormat(orderLine.createdDate),
              wishDate: getDutchDateFormat(orderLine.wishDate) || 'Geen',
              deliveryDate: getDutchDateFormat(orderLine.deliveryDate) || 'Geen',
              invoiceDate: getDutchDateFormat(orderLine.invoiceDate) || 'Geen',
              terminationRequestDate: getDutchDateFormat(orderLine.terminationRequestDate) || 'Geen',
              service: servicesStringToIcons(orderLine.service.type),
              status: statusStringToIcons(orderLine.status.icon),
              comment: orderLine.hasComments ? new Array(messageIcon) : new Array(),
            };
          });

          this.updateMeta(response.data.meta);
          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error: any) => {
          this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
        },
      ).finally(() => this.$store.dispatch('setLoadOverlay', false));
    }

    public created() {
      this.keepMetaSavedInState();
      this.setDefaultSort('-createdDate');
      this.pageMeta.status = (this.$route.params.status) ? this.$route.params.status : '';
      this.loadList(this.pageMeta);
    }

    private getProductName(orderLine: any): string {
      let productName = orderLine.product.class
          ? `${orderLine.product.class} - ${orderLine.product.name}` : orderLine.product.name;

      if (orderLine?.additionalData === null || orderLine?.additionalData === undefined) {
        return productName;
      }

      const phoneNumber = getPhoneNumberFromOrderLine(orderLine);

      if (phoneNumber) {
        return productName + ' (' + phoneNumber + ')';
      }

      return productName;
    }
  }
</script>

<!-- STYLE -->
<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
  @import '~@deanone/dean-components/src/scss/modules/transitions';

  .filter {
    display: flex;
  }

  button {
    fill: var(--color-dark, $color-dark);
    background: none;
    padding: 5px;
    border: 0;
    margin: 5px;
    transition: fill .3s;
    border-radius: 5px;
  }

  button.active,
  button:hover {
    fill: var(--color-secondary, $color-secondary);
  }

  .top-bar {
    display: inline-block;
  }

  :deep(.top-bar .hd-6.columns) {
    width: 100%;
  }
</style>
